<template>
  <div class="full-item flex flex-direction align-center justify-center">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      :label-position="UI.isMobile ? 'top' : 'left'"
      :label-width="UI.isMobile ? undefined : '80px'"
      style="width: 90%"
    >
      <el-form-item label="用户名" prop="username">
        <el-input
          placeholder="请输入用户名"
          clearable
          v-model="loginForm.username"
        ></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input
          placeholder="请输入密码"
          show-password
          clearable
          v-model="loginForm.password"
        ></el-input>
      </el-form-item>
    </el-form>

    <Vcode :show="isShow" @success="onVerifySuccess" @close="onVerifyClose" />

    <el-button
      class="login-button padding-xs margin-top"
      type="primary"
      size="mini"
      @click="loginSubmit()"
    >
      登录
    </el-button>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import { login } from '@/servers/user.js';

import { setStorage } from '@/utils/storageUtils.js';
import Vcode from 'vue-puzzle-vcode';
import { showErrorMsg } from '@/utils/uiUtils.js';

export default {
  components: {
    Vcode,
  },

  data() {
    return {
      isShow: false,
      loginForm: {
        username: '',
        password: '',
        role: 1000
      },
      loginRules: {
        username: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur',
          },
        ],
      },
    };
  },

  computed: {
    ...mapState(['User', 'UI']),
  },

  created() {
    setStorage('token', '');
    setStorage('refreshToken', '');
    console.log(123)
  },

  methods: {
    ...mapMutations(['getUserState']),

    toChangePwd: function() {
      this.$router.push({
        name: 'changepwd',
      });
    },

    onVerifySuccess: function() {
      this.isShow = false;
      let that = this;
      login(this.loginForm, function(res) {
        setStorage('token', res.token);
        setStorage('refreshToken', res.refresh_token);
        setStorage('tokenExpiredTime', res.token_expired_time);
        that.User.hasLogin = true;
        setTimeout(function() {
          that.getUserState();
        }, 1000);
        that.$router.replace({
          name: 'index',
        });
      });
    },

    onVerifyClose: function() {
      this.isShow = false;
    },

    loginSubmit: function() {
      let that = this;
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          that.isShow = true;
        } else {
          showErrorMsg('请检查输入的参数.');
        }
      });
    },
  },
};
</script>
<style scoped>
.login-button {
  width: 200px;
}

.verify-bar-area {
  border-radius: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue